export class BaseModel {
    constructor(data) {
        Object.assign(this, data);
    }

    attributes: Object = null;

    get(key) {
        return this.attributes ? this.attributes[key] : undefined;
    }

    set(key, value) {
        this.attributes[key] = value;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/common/base-model.ts